/**
 * FasciaBraccio — la fascia da capitano (oro) e da vice (argento).
 *
 * Estratta dal Pitch (Andrea 2026-09-08) per riusarla anche in Gestione
 * Rosa, dove segna i 5 papabili capitani.
 */

/** Fascia da capitano sul braccio (Andrea 2026-09-02): grafica minimal
 * dal riferimento — fascia a bande con cerchio centrale e lettera.
 * Oro/C per il capitano, argento/VC per il vice. */
export function FasciaBraccio({ vice = false }: { vice?: boolean }) {
  const gid = vice ? "fascia-arg" : "fascia-oro";
  const scuro = vice ? "#3f3f46" : "#78350f";
  const chiaro = vice ? "#fafafa" : "#fef9c3";
  return (
    <svg viewBox="0 0 44 19" className="w-full h-auto drop-shadow">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          {vice ? (
            <>
              <stop offset="0" stopColor="#e4e4e7" />
              <stop offset="0.5" stopColor="#ffffff" />
              <stop offset="1" stopColor="#a1a1aa" />
            </>
          ) : (
            <>
              <stop offset="0" stopColor="#fde047" />
              <stop offset="0.5" stopColor="#fbbf24" />
              <stop offset="1" stopColor="#ca8a04" />
            </>
          )}
        </linearGradient>
      </defs>
      {/* bordi tubolari alto/basso */}
      <rect
        x="1"
        y="0.5"
        width="42"
        height="3"
        rx="1.5"
        fill={`url(#${gid})`}
        stroke={scuro}
        strokeWidth="1.1"
      />
      <rect
        x="1"
        y="15.5"
        width="42"
        height="3"
        rx="1.5"
        fill={`url(#${gid})`}
        stroke={scuro}
        strokeWidth="1.1"
      />
      {/* corpo fascia */}
      <rect
        x="3"
        y="2.5"
        width="38"
        height="14"
        fill={`url(#${gid})`}
        stroke={scuro}
        strokeWidth="1.3"
      />
      {/* cerchio centrale con lettera */}
      <circle cx="22" cy="9.5" r="7" fill={chiaro} stroke={scuro} strokeWidth="1.5" />
      <text
        x="22"
        y={vice ? 11.7 : 12.6}
        textAnchor="middle"
        fontFamily="Montserrat, system-ui, sans-serif"
        fontWeight="800"
        fontSize={vice ? 6 : 8.5}
        fill={scuro}
      >
        {vice ? "VC" : "C"}
      </text>
    </svg>
  );
}
